/** Chave usada no sessionStorage para persistir o email no formulário de login. */
export const LOGIN_EMAIL_STORAGE_KEY = 'synap-login-email'

/** Último email usado em login bem-sucedido (localStorage, entre sessões). */
export const LAST_LOGIN_EMAIL_KEY = 'synap-last-login-email'

export const readLastLoginEmail = (): string => {
  if (typeof window === 'undefined') return ''
  return localStorage.getItem(LAST_LOGIN_EMAIL_KEY)?.trim() ?? ''
}

export const rememberLastLoginEmail = (email: string): void => {
  if (typeof window === 'undefined') return
  const trimmed = email.trim()
  if (!trimmed) return
  localStorage.setItem(LAST_LOGIN_EMAIL_KEY, trimmed)
}

/** SEC-042: limpar email lembrado no logout (opcional — reduz shoulder surfing). */
export const clearLastLoginEmail = (): void => {
  if (typeof window === 'undefined') return
  localStorage.removeItem(LAST_LOGIN_EMAIL_KEY)
  sessionStorage.removeItem(LOGIN_EMAIL_STORAGE_KEY)
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const MIN_PASSWORD_LENGTH = 8

/**
 * Valida o email do formulário de login.
 * Retorna mensagem de erro ou null se válido.
 */
export function validateLoginEmail(email: string): string | null {
  const trimmed = email.trim()
  if (!trimmed) return 'Informe o email.'
  if (!EMAIL_REGEX.test(trimmed)) return 'Informe um email válido.'
  return null
}

/**
 * Valida a senha do formulário de login.
 * Retorna mensagem de erro ou null se válido.
 */
export function validateLoginPassword(password: string): string | null {
  if (!password) return 'Informe a senha.'
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `A senha deve ter no mínimo ${MIN_PASSWORD_LENGTH} caracteres.`
  }
  return null
}

/**
 * Valida o formulário de login completo.
 * Retorna o primeiro erro encontrado ou null se válido.
 */
export function validateLoginForm(email: string, password: string): string | null {
  const emailError = validateLoginEmail(email)
  if (emailError) return emailError
  const passwordError = validateLoginPassword(password)
  if (passwordError) return passwordError
  return null
}
